<template>
  <div class="dialog_size">
      <Tile :title="title" :startUpAnimation="false">
          <slot></slot>
      </Tile>
  </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        }
    }
}
</script>

<style>
.dialog_size {
    display: flex;
    /*max-height: 74vh;*/
    overflow-x: auto;
}

@media only screen and (min-width: 600px) {
  .dialog_size {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
    }
}

@media only screen and (min-width: 900px) {
  .dialog_size {
        width: 30%;
        margin-left: auto;
        margin-right: auto;
    }
}
</style>